import { render, staticRenderFns } from "./PostsMainPage.vue?vue&type=template&id=e6415f66&scoped=true&"
import script from "./PostsMainPage.vue?vue&type=script&lang=js&"
export * from "./PostsMainPage.vue?vue&type=script&lang=js&"
import style0 from "./PostsMainPage.vue?vue&type=style&index=0&id=e6415f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6415f66",
  null
  
)

export default component.exports